export default __webpack_public_path__ + "static/form-thank-you-smiley--mobile-d3f27cb299f4745fb23aee39fc4f4348.webp";